import _defineProperty from "/codebuild/output/src3618121175/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
import { resetComponent } from '../../style';
import { initZoomMotion } from '../../style/motion';
import getArrowStyle, { getArrowOffsetToken, MAX_VERTICAL_CONTENT_RADIUS } from '../../style/placementArrow';
import { getArrowToken } from '../../style/roundedArrow';
import { genPresetColor, genStyleHooks, mergeToken } from '../../theme/internal';
var genTooltipStyle = function genTooltipStyle(token) {
  var componentCls = token.componentCls,
    tooltipMaxWidth = token.tooltipMaxWidth,
    tooltipColor = token.tooltipColor,
    tooltipBg = token.tooltipBg,
    tooltipBorderRadius = token.tooltipBorderRadius,
    zIndexPopup = token.zIndexPopup,
    controlHeight = token.controlHeight,
    boxShadowSecondary = token.boxShadowSecondary,
    paddingSM = token.paddingSM,
    paddingXS = token.paddingXS;
  return [_defineProperty({}, componentCls, Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token)), _defineProperty(_defineProperty(_defineProperty({
    position: 'absolute',
    zIndex: zIndexPopup,
    display: 'block',
    width: 'max-content',
    maxWidth: tooltipMaxWidth,
    visibility: 'visible',
    // When use `autoArrow`, origin will follow the arrow position
    '--valid-offset-x': 'var(--arrow-offset-horizontal, var(--arrow-x))',
    transformOrigin: ["var(--valid-offset-x, 50%)", "var(--arrow-y, 50%)"].join(' '),
    '&-hidden': {
      display: 'none'
    },
    '--antd-arrow-background-color': tooltipBg
  }, "".concat(componentCls, "-inner"), {
    minWidth: '1em',
    minHeight: controlHeight,
    padding: "".concat(unit(token.calc(paddingSM).div(2).equal()), " ").concat(unit(paddingXS)),
    color: tooltipColor,
    textAlign: 'start',
    textDecoration: 'none',
    wordWrap: 'break-word',
    backgroundColor: tooltipBg,
    borderRadius: tooltipBorderRadius,
    boxShadow: boxShadowSecondary,
    boxSizing: 'border-box'
  }), ["&-placement-left", "&-placement-leftTop", "&-placement-leftBottom", "&-placement-right", "&-placement-rightTop", "&-placement-rightBottom"].join(','), _defineProperty({}, "".concat(componentCls, "-inner"), {
    borderRadius: token.min(tooltipBorderRadius, MAX_VERTICAL_CONTENT_RADIUS)
  })), "".concat(componentCls, "-content"), {
    position: 'relative'
  })), genPresetColor(token, function (colorKey, _ref) {
    var darkColor = _ref.darkColor;
    return _defineProperty({}, "&".concat(componentCls, "-").concat(colorKey), _defineProperty(_defineProperty({}, "".concat(componentCls, "-inner"), {
      backgroundColor: darkColor
    }), "".concat(componentCls, "-arrow"), {
      '--antd-arrow-background-color': darkColor
    }));
  })), {
    // RTL
    '&-rtl': {
      direction: 'rtl'
    }
  })),
  // Arrow Style
  getArrowStyle(token, 'var(--antd-arrow-background-color)'), // Pure Render
  _defineProperty({}, "".concat(componentCls, "-pure"), {
    position: 'relative',
    maxWidth: 'none',
    margin: token.sizePopupArrow
  })];
};
// ============================== Export ==============================
export var prepareComponentToken = function prepareComponentToken(token) {
  return Object.assign(Object.assign({
    zIndexPopup: token.zIndexPopupBase + 70
  }, getArrowOffsetToken({
    contentRadius: token.borderRadius,
    limitVerticalRadius: true
  })), getArrowToken(mergeToken(token, {
    borderRadiusOuter: Math.min(token.borderRadiusOuter, 4)
  })));
};
export default (function (prefixCls) {
  var injectStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var useStyle = genStyleHooks('Tooltip', function (token) {
    var borderRadius = token.borderRadius,
      colorTextLightSolid = token.colorTextLightSolid,
      colorBgSpotlight = token.colorBgSpotlight;
    var TooltipToken = mergeToken(token, {
      // default variables
      tooltipMaxWidth: 250,
      tooltipColor: colorTextLightSolid,
      tooltipBorderRadius: borderRadius,
      tooltipBg: colorBgSpotlight
    });
    return [genTooltipStyle(TooltipToken), initZoomMotion(token, 'zoom-big-fast')];
  }, prepareComponentToken, {
    resetStyle: false,
    // Popover use Tooltip as internal component. We do not need to handle this.
    injectStyle: injectStyle
  });
  return useStyle(prefixCls);
});